import { render, staticRenderFns } from "./ChartProvidersOverview.vue?vue&type=template&id=bf9d1a1c&"
import script from "./ChartProvidersOverview.vue?vue&type=script&lang=js&"
export * from "./ChartProvidersOverview.vue?vue&type=script&lang=js&"
import style0 from "./ChartProvidersOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ChartProvidersOverview.vue?vue&type=custom&index=0&blockType=tsv"
if (typeof block0 === 'function') block0(component)

export default component.exports